export default class DtoSelection {
    constructor(obj) {
        this.code = obj.code
        this.name = obj.name
        this.listType = obj.listType || 0
        this.parentCode = obj.parentCode
        this.default = obj.default
    }
}